export const BuildInfo = {timestamp:1779313939000}
